module.exports = __webpack_public_path__ + "img/nav-futures.8fb870a.svg";